<template>
  <div>
    <div class="yu-flex yu-flex-start">
      <div class="image-box" v-for="(el, index) in fileList" :key="index">
        <img :src="getPoster(el)" :alt="el.fileName" style="width: 100%" />
        <div class="img-close" @click.stop="onFileDelete(index)">
          <i class="icon-ccui-add-sup"></i>
        </div>
      </div>

      <el-upload
        ref="upload"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="beforeAvatarUpload"
        :auto-upload="true"
        :limit="limit"
        :accept="accept.join(',')"
        :action="importFileUrl"
      >
        <div v-if="fileList.length < limit">
          <div
            v-if="type === 'LOGO'"
            class="image-box logo-box yu-flex-col"
          >
            <i class="icon-ccui-camera"></i>
            <span style="font-size: 10px;line-height: 20px;">上传LOGO</span>
          </div>
          <div v-else class="image-box yu-flex-col bgd">
            <i class="icon-ccui-add-sup"></i>
          </div>
        </div>
      </el-upload>
    </div>
    <div style="color: #9b9b9b; font-size: 13px;font-weight: 400;">
      <slot name="tip"
        >上传文件支持格式：{{ accept.join(",") }}，每个文件不超过
        {{ fileSize }}MB</slot
      >
    </div>
  </div>
</template>

<script>
import imgBase64 from "@/views/business-open-shop/components/img-base64";
export default {
  props: {
    type: {
      type: String,
      default: "other",
    },
    accept: {
      type: Array,
      default: () => [".pdf", ".xls", ".xlsx", ".doc", ".docx"],
    },
    fileSize: {
      type: [String, Number],
      default: 15,
    },
    size: {
      type: Array,
      default: () => [],
    },
    action: {
      type: String,
      default: "/apis/sra/reg/users/signup/uploadFileToOss",
    },
    limit: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    importFileUrl() {
      return this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + this.action;
    },
  },
  data() {
    return {
      fileList: [],
      titleData: {},
    };
  },
  methods: {
    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      console.log(response);
      if (response.code === "0") {
        this.$message({
          type: "success",
          message: "文件上传成功！",
          offset: document.body.clientHeight / 2 - 21,
        });
        this.fileList.push(response.data[0]);

        this.$emit("success", this.fileList);
      } else {
        this.$message({
          type: "error",
          message: "文件上传失败！",
          offset: document.body.clientHeight / 2 - 21,
        });
      }
    },
    onFileDelete(index) {
      this.fileList.splice(index, 1);
      this.$emit("success", this.fileList);
    },
    beforeAvatarUpload(file) {
      const listFileSize = file.size / 1024 / 1024;
      if (listFileSize > this.fileSize) {
        this.$message({
          type: "error",
          message: `上传图片大小不能超过 ${this.fileSize}MB!`,
          offset: document.body.clientHeight / 2 - 21,
        });
        return false;
      } else {
        const fileType = "." + file.name.match(/\.(\w+)$/)[1];
        if (!this.accept.includes(fileType)) {
          this.$message({
            type: "error",
            message: `上传文件支持格式：${this.accept.join(",")}`,
            offset: document.body.clientHeight / 2 - 21,
          });
          return false;
        } else if (this.size.length == 2) {
          const _this = this;
          const isSize = new Promise((resolve, reject) => {
            const img = new Image();
            const _URL = window.URL || window.webkitURl;
            img.onload = () => {
              file.width = img.width; //图片宽度
              file.height = img.height; //图片高度
              const valid =
                img.width <= _this.size[0] && img.height <= _this.size[1]; //上传图片尺寸判定
              valid ? resolve() : reject(new Error("error"));
            };
            img.src = _URL.createObjectURL(file);
          }).then(
            () => {
              return file;
            },
            () => {
              _this.$message({
                showClose: true,
                type: "error",
                message: `上传图片尺寸必须在${_this.size[0]}*${_this.size[1]}以内！`,
                ccuiCustom: true,
              });
              return Promise.reject(new Error("error"));
            }
          );
          return isSize;
        }
      }
      return true;
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file, "水电费水电费");
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.uploadId = res.data[0].uploadId;
      this.form.shopLogoUrl = res.data[0].downloadUrl;
    },

    getPoster(file) {
      const filetype = file.fileName.match(/\.(\w+)$/)[1];
      const imgtype = ["png", "jpg", "jpeg", "gif"];

      const poster = [
        {
          type: "docx",
          icon: imgBase64.doc,
        },
        {
          type: "pdf,PDF",
          icon: imgBase64.pdf,
        },
        {
          type: "xlsx,XLSX",
          icon: imgBase64.xls,
        },
        {
          type: "txt,TXT",
          icon: imgBase64.txt,
        },
      ];
      if (imgtype.includes(filetype)) {
        return file.downloadUrl;
      } else if (poster.find((el) => el.type.includes(filetype))) {
        return poster.find((el) => el.type.includes(filetype)).icon;
      } else {
        return file.downloadUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.yu-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.yu-flex-start {
  justify-content: flex-start;
}
.image-box {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #DFDFDF;
  color: #b1b1b1;
  font-size: 24px;
  .img-close {
    position: absolute;
    top: -6px;
    right: -2px;
    font-size: 24px;
    transform: rotate(45deg);
    cursor: pointer;
  }
}
.logo-box {
  width: 65px;
  height: 65px;
  border: 1px dashed #979797;
}
.bgd {
  background: #f1f1f1;
}
.yu-flex-col {
  flex-direction: column;
}
</style>